import { PaymentSubmitProps } from '@msc-b2c/interfaces/types';
import { GuestCheckbox } from '../../../guestcheckbox/GuestCheckbox';
import styles from '../../paymentbox.module.scss';
import { sanitize } from '@msc-b2c/shared-utils';

const PaymentSubmit = ({ id, terms, onCheck, checked, children }: PaymentSubmitProps) => {
  const termsHtml = terms ? terms.replace(/<a /g, '<a target="_blank" ') : '';
  const sanitizedTermsHtml = termsHtml
    ? sanitize(termsHtml, {
        ADD_ATTR: ['target'],
      })
    : '';

  const termsLabelId = `${id}-terms-label`;

  return (
    <div className={styles.submitContainer}>
      <div className={styles.terms}>
        <GuestCheckbox
          id={id}
          ariaLabelledBy={termsLabelId}
          onChange={onCheck}
          checked={checked}
        />
        <span
          id={termsLabelId}
          dangerouslySetInnerHTML={{ __html: sanitizedTermsHtml }}
        ></span>
      </div>
      {children}
    </div>
  );
};

export default PaymentSubmit;
